import { PixKeyType } from "./key-type.enum";

export class PixGenerateQrCode {
	codigo: string;
	tipoChave: PixKeyType;
	informacaoAdicional: string;
	formato = 'D';
	codigoTransacao: string;
	tipo: "ESTATICO";
	valor: number;

	constructor(
		codigo: string,
		tipoChave: PixKeyType,
		informacaoAdicional: string,
		formato = 'D',
		codigoTransacao: string,
		tipo: "ESTATICO",
		valor: number
	) {
		this.codigo = codigo;
		this.tipoChave = tipoChave;
		this.informacaoAdicional= informacaoAdicional;
		this.formato = formato;
		this.codigoTransacao = codigoTransacao;
		this.tipo = tipo;
		this.valor = valor;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/models/generate-qrcode.model.ts